import useSWR from 'swr';
import api from 'utils/api';
import type { PublishingView } from 'types/publishing';

/** `GET /publishing/artists/:id/view`; a 404 (no snapshot / artist absent) is `notFound`, not an error. */
export function usePublishingView(spotifyArtistId: string | null) {
  const { data, error, mutate } = useSWR<PublishingView>(
    spotifyArtistId ? ['publishing-view', spotifyArtistId] : null,
    () => api.publishing.getView({ id: spotifyArtistId as string }),
    { revalidateOnFocus: false, revalidateOnReconnect: true, shouldRetryOnError: false }
  );
  const notFound = error?.status === 404;
  return {
    view: data ?? null,
    isLoading: !!spotifyArtistId && !data && !error,
    notFound,
    error: error && !notFound ? error : null,
    refetch: () => mutate(),
  };
}
